/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable import/first */
// Entry point for the feed.web.js bundle, this is the first JS from our app that runs
import * as Sentry from '@sentry/react';
import {
    Dedupe as DedupeIntegration,
    ExtraErrorData as ExtraErrorDataIntegration,
} from '@sentry/integrations';

function getEnv(host = 'dev.evbqa.com') {
    if (host.indexOf('eventbrite') > -1) {
        return 'production';
    }

    if (host.indexOf('dev') > -1) {
        return 'dev';
    }

    if (host.indexOf('evbstage') > -1) {
        return 'stage';
    }

    if (host.indexOf('evbqa') > -1) {
        return 'qa';
    }

    return 'dev';
}

const shouldUseSentry = () => {
    const env = getEnv(window.location.host);

    return env === 'production' || env === 'qa' || env === 'stage';
};

const setSentryCustomTags = () => {
    if (window.__SERVER_DATA__.guest_id) {
        Sentry.setTag('guest_id', window.__SERVER_DATA__.guest_id);
    }

    Sentry.setTag('page_locale', window.__i18n__?.locale || '');

    if (window.location && window.location.pathname) {
        if (!(window.location.pathname.indexOf('/d/') === 0)) {
            Sentry.setTag('sub_app', 'home');
        } else if (window.location.pathname.indexOf('/events/') === 0) {
            Sentry.setTag('sub_app', 'browse');
        } else {
            Sentry.setTag('sub_app', 'search');
        }
    }
};

if (shouldUseSentry) {
    Sentry.init({
        dsn:
            'https://9a651a886d0d43a79d58cdcefa083e97@o375540.ingest.sentry.io/5474383',
        integrations: [
            new DedupeIntegration(),
            new ExtraErrorDataIntegration(),
        ],
        release: window.__SERVER_DATA__.app_version,
        environment: getEnv(window.location.host),
    });

    if (window.__SERVER_DATA__.user.email) {
        const sentryUser = {
            email: window.__SERVER_DATA__.user.email,
            id: window.__SERVER_DATA__.user.publicId,
        };

        // MUST have one of email, id, username, or ip to call setUser()
        Sentry.setUser(sentryUser);
    }

    setSentryCustomTags();
}

// These are the minimum polyfills so that legacy browsers can
// dynamically import
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.array.includes';

// Always polyfill generators because we can't reliably detect
// generator support in browser
import 'regenerator-runtime/runtime';

// polyfill requestAnimationFrame for old browsers
import 'raf/polyfill';

// import featureDetect from 'feature-detect-es6';

import './index.scss';
import './EdsOverrides.scss';

// Sometimes dynamic imports fail on slow connections
// For now just silence the errors to stop sending (there are too many)
// eslint-disable-next-line func-style
function genericDynamicImportErrorHandler(err) {
    if (process.env.NODE_ENV !== 'production') {
        throw err;
    }
    return null;
}

// These CSS imports we still want, but do a dynamic import here so they are
// not included in the first bundle, they get loaded asyncronously
// import('@eb/eds-css/src/eds.scss').catch(genericDynamicImportErrorHandler);

// if (featureDetect.all('class', 'spread', 'let', 'arrowFunction')) {
import('./index.post').catch(genericDynamicImportErrorHandler);
